import { Directive, input } from '@angular/core'

import { Card, Cmp, Layout } from 'app/core/cms/type-unions'

import { DynamicInsert } from './dynamic-insert'
import { CONTENT_MAPPING } from './shared-mapping'

@Directive({ selector: 'ng-template[paiInsertDynamicContent]', standalone: true })
export class InsertDynamicContentDirective extends DynamicInsert<typeof CONTENT_MAPPING> {
  readonly data = input.required<Layout | Card | Cmp>({ alias: 'paiInsertDynamicContent' })
  protected readonly blockMapping = CONTENT_MAPPING
}
